export enum Sector {
  Transport,
  Industry,
  Agriculture,
  Energy,
  Other,
  None,
  Emission,
}
